import React, {Component} from 'react';
import {Card} from "react-bootstrap";
import "./home_page_mobile_card3.scss";
import TemplatePagePlaceholder from "../../../template_page/template_page_placeholder/template_page_placeholder";
import ReactPlayer from "react-player";

class HomePageMobileCard3 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            touched: false,
            playing: false,
            isHidden: false
        };
        this.notizieRef = React.createRef();
    }

    playVideo = () => {
        this.setState({
            isHidden: true,
            playing: true
        })
    };

    render() {
        return <Card className={"home-page-mobile-card3 " + (this.state.touched ? "touched" : "")}>
            {this.props.image ? <TemplatePagePlaceholder
                    className={'player card3-video'} image={this.props.image}
                    video={this.props.video}/> :
                <div className="card3-video">
                    <ReactPlayer className="card-video"
                                 url={this.props.video}
                                 ref={this.notizieRef}
                                 controls={!this.state.isHidden}
                                 playing={this.state.playing} muted/>
                    {!this.state.isHidden &&
                    <button className="card3-video-button" onClick={() => this.playVideo()}>
                        <div className="card3-video-button-shadow"/>
                        <div className="card3-triangle"/>
                    </button>
                    }
                </div>
            }

            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <div className="mobButton-top"><a href={this.props.url}/></div>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <div className="mobButton-right"><a href={this.props.url}/></div>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <div className="mobButton-bottom"><a href={this.props.url}/></div>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <div className="mobButton-left"><a href={this.props.url}/></div>
        </Card>;
    }
}

export default HomePageMobileCard3;
